export const possibleBids = [
  'Blind Nil',
  'Nil',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
];

export const possibleActuals = [
  0,
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
];

export const BLIND_NIL = 'Blind Nil';
export const NIL = 'Nil';
